import React, { Component } from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import classNames from 'classnames'
import { Button, Dropdown, ButtonGroup } from 'react-bootstrap';

import PusherContext from '../../../../_contexts/PusherContext';

class RoomCard extends Component
{
  static contextType = PusherContext

  constructor(props) {
    super(props)

    this.state = {
      isConnected: false,
      patientOnline: false
    }

    this.connectionChange = this.connectionChange.bind(this)
  }

  componentDidMount() {
    this.initiateSocket();
  }

  componentWillUnmount() {
    if (this.presenceChannel) {
      this.presenceChannel.unbind()
      this.context.unsubscribe(`presence-telehealth_room.${this.props.room.id}`)
    }

    this.context.connection.unbind('state_change', this.connectionChange, this)
  }

  initiateSocket () {
    this.setState({
      isConnected: this.context.connection.state === 'connected'
    })

    this.context.connection.bind('state_change', this.connectionChange, this)

    this.presenceChannel = this.context.subscribe(`presence-telehealth_room.${this.props.room.id}`);

    this.presenceChannel
      .bind('pusher:subscription_succeeded', data => {      
        this.setState({
          patientOnline: this.isPatientOnline(data.members)
        })
      })
      .bind('pusher:member_added', data => {
        this.setState({
          patientOnline: this.isPatientOnline(this.presenceChannel.members.members)
        })
      })
      .bind('pusher:member_removed', data => {
        this.setState({
          patientOnline: this.isPatientOnline(this.presenceChannel.members.members)
        })
      })
  }

  connectionChange(state) {
    this.setState({
      isConnected: state.current === 'connected'
    });
  }

  isPatientOnline (members) {
    return Object.keys(members).find(memberId => {
      return parseInt(memberId) === parseInt(this.props.room.userProfile.userId)
    })
  }

  render() {
    const { room } = this.props;

    const cardClass = classNames('card mb-4', {
      'border-success': this.state.isConnected && this.state.patientOnline
    });

    return <div className={cardClass}>
      <div className="card-body">
        <h5>{`${room.userProfile.firstName} ${room.userProfile.lastName}`}</h5>
        { this.state.isConnected && this.state.patientOnline &&
          <span className="badge badge-success mb-3"><i className="fas fa-check-circle"></i>&nbsp;Patient is in the room</span>
        }

        { this.state.isConnected && !this.state.patientOnline &&
          <span className="badge badge-warning mb-3"><i className="fas fa-times-circle"></i>&nbsp;Patient is not in the room</span>
        }

        <p className="card-text mb-2">{room.questionnaire.title}</p>

        <p className="text-muted m-0"><small><i className="far fa-clock"></i>&nbsp;{moment.tz(room.appointmentDate.date, room.appointmentDate.timezone).local().format('LL [at] LT')}</small></p>
        <p className="text-muted m-0"><small><i className="fas fa-user-md"></i>&nbsp;{`${room.doctor.firstName} ${room.doctor.lastName}`}</small></p>
        <p className="text-muted"><small><i className="far fa-question-circle"></i>&nbsp;{room.telemedicineType === 'video' ? 'Real-Time Video' : 'Asynchronous'}</small></p>

        <Dropdown as={ButtonGroup}>
          <Button
            as={Link}
            to={`/telehealth/${room.id}`}
            variant="success"
            type='button'
            block>Enter Telehealth Room
          </Button>

          <Dropdown.Toggle split variant="success" id="dropdown-split-basic" />

          <Dropdown.Menu>
            <Dropdown.Item as={Link} to={`/telehealth/${room.id}/view`}>View Questions</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>

        {/* <Link className="btn btn-success btn-block" to={`/telehealth/${room.id}`}>Enter Telehealth Room</Link> */}
      </div>
    </div>
  }
}

export default RoomCard